import { render, staticRenderFns } from "./StructureV2.vue?vue&type=template&id=5dc34a44&scoped=true"
import script from "./StructureV2.vue?vue&type=script&lang=js"
export * from "./StructureV2.vue?vue&type=script&lang=js"
import style0 from "./StructureV2.vue?vue&type=style&index=0&id=5dc34a44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc34a44",
  null
  
)

export default component.exports